/* eslint-disable @typescript-eslint/no-explicit-any */
// import { Node } from "@iventis/domain-model/model/node";
import { NodeType } from "@iventis/domain-model/model/nodeType";
import { FunctionComponent } from "react";
import { TreeBrowserNode } from "./data-types";

export type GetInteractivity<TNode extends TreeBrowserNode> = (
    node: TNode
) => { selectable: { disabled: boolean; tooltip?: string }; disabled: boolean; draggable: boolean; isNameClickable: boolean };

export type NodeComponentProps<TNode extends TreeBrowserNode, TExtraProps extends any = undefined> = {
    node: TNode;
    containerElement?: HTMLElement;
    /**
     * @deprecated
     * Whether the node is expanded. Use contextual state instead of this property now.
     */
    expanded?: boolean;
    extraProps?: TExtraProps;
    parentNodeType?: NodeType;
    getInteractivity?: GetInteractivity<TNode>;
};

export type NodeComponent<TNode extends TreeBrowserNode, TExtraProps extends any = undefined> = FunctionComponent<NodeComponentProps<TNode, TExtraProps>>;

export enum FolderBrowserView {
    List = "list",
    Tile = "tile",
}
